module.exports = __webpack_public_path__ + "static/media/Error acceso restringido.6659ceb3.gif";